<doka-modal-wrapper (close)="closeModal()">
  <ng-template #title>{{
    itemTemplate() == undefined
      ? ("MasterData.TemplateSlideOver.CreateTitle" | i18nextEager)
      : ("MasterData.TemplateSlideOver.UpdateTitle" | i18nextEager)
  }}</ng-template>

  <ng-template #content>
    <form [formGroup]="form">
      <div class="flex flex-col gap-lg">
        <doka-select
          class="w-full"
          formControlName="countryId"
          data-testid="template-country-select"
          [label]="'MasterData.TemplateSlideOver.Country' | i18nextEager"
          [placeholder]="'Common.Select' | i18nextEager"
        >
          @for (country of countries.value()?.data; track country.id) {
            <doka-select-option [value]="country.id" [label]="country.countryName"></doka-select-option>
          }
        </doka-select>

        <doka-select
          class="w-full"
          formControlName="isoCurrencyCode"
          data-testid="template-currency-select"
          [label]="'MasterData.TemplateSlideOver.Currency' | i18nextEager"
          [placeholder]="'Common.Placeholder' | i18nextEager"
        >
          @for (currency of currencies.value()?.data; track currency) {
            <doka-select-option
              [value]="currency.isoCurrencyCode"
              [label]="currency.isoCurrencyCode + ' - ' + currency.currencySymbol"
            ></doka-select-option>
          }
        </doka-select>

        <doka-number-input
          formControlName="cost"
          data-testid="template-cost-input"
          [label]="'MasterData.TemplateSlideOver.Cost' | i18nextEager"
          [unit]="
            itemTemplate()?.isoCurrencyCode
              ? getSymbolForCurrencyCode(itemTemplate()?.isoCurrencyCode)
              : userInfoService.getCurrencySymbol()
          "
          [alert]="
            form.controls.cost.touched && form.controls.cost.hasError('required')
              ? ('Common.Required' | i18nextEager)
              : ''
          "
        />
        <doka-number-input
          formControlName="lifetimeInMonths"
          data-testid="template-lifetime-input"
          [label]="'MasterData.TemplateSlideOver.Lifetime' | i18nextEager"
          [unit]="'MasterData.TemplateSlideOver.MonthsUnit' | i18nextEager"
        />
        <doka-text-field
          formControlName="deliveryTimeInMonths"
          data-testid="template-delivery-time-input"
          [label]="'MasterData.TemplateSlideOver.DeliveryTime' | i18nextEager"
          [placeholder]="'MasterData.TemplateSlideOver.DeliveryTimePlaceholder' | i18nextEager"
          [alert]="
            form.controls.deliveryTimeInMonths.touched && form.controls.deliveryTimeInMonths.hasError('required')
              ? ('Common.Required' | i18nextEager)
              : ''
          "
        />

        <doka-select
          class="w-full"
          formControlName="availabilityState"
          data-testid="template-availability-state-select"
          [label]="'MasterData.TemplateSlideOver.AvailabilityState' | i18nextEager"
          [placeholder]="'Common.Select' | i18nextEager"
          [alert]="
            form.controls.availabilityState.touched && form.controls.availabilityState.hasError('required')
              ? ('Common.Required' | i18nextEager)
              : ''
          "
        >
          @for (state of availablityStateKeys; track state) {
            <doka-select-option
              [value]="state"
              [label]="'AvailabilityState.' + state | i18nextEager"
            ></doka-select-option>
          }
        </doka-select>
      </div>
    </form>
  </ng-template>
  <ng-template #footer>
    <div class="flex flex-col gap-sm w-full">
      <div class="flex w-full gap-md px-6 pt-4 items-center justify-end">
        <doka-button
          [disabled]="isLoading()"
          (click)="closeModal()"
          color="secondary"
          data-testid="template-cancel-button"
          >{{ "Common.Cancel" | i18nextEager }}</doka-button
        >
        <doka-button
          type="submit"
          [disabled]="form.invalid || isLoading()"
          (click)="submit()"
          color="primary"
          data-testid="template-save-button"
          >{{ "Common.Save" | i18nextEager }}</doka-button
        >
      </div>
    </div>
  </ng-template>
</doka-modal-wrapper>
